import {useMutation} from '@tanstack/react-query'

import {creditCheck, getPersonInfo, sendForSigning, uploadDocument} from './api'
import type {
  CreditCheckRequest,
  CreditCheckResponse,
  PersonInfoRequest,
  PersonInfoResponse,
  SigningRequest,
  UploadDocumentRequest,
} from './types'

export const useSendForSigning = () => {
  return useMutation<string, unknown, SigningRequest>({
    mutationFn: sendForSigning,
  })
}

export const useUploadDocument = () => {
  return useMutation<boolean, unknown, UploadDocumentRequest>({
    mutationFn: uploadDocument,
  })
}

export const useCreditCheck = () => {
  return useMutation<CreditCheckResponse, unknown, CreditCheckRequest>({
    mutationFn: creditCheck,
  })
}

export const usePersonInfo = () => {
  return useMutation<PersonInfoResponse, unknown, PersonInfoRequest>({
    mutationFn: getPersonInfo,
  })
}
